import { useQuery } from '@tanstack/react-query';
import { backendHost } from 'config/backendRoutes';
import { FOUNDATION } from 'config/features';
import { get } from 'util/fetch';
import { useOrganizationShortName } from '../../../store/hooks/useOrganizationShortName';
import { useToken } from '../../../store/hooks/useToken';
import { QUERY_KEYS } from './queryKeys';

export const multiSite = (token, organizationShortName) =>
  get(`${backendHost}/${organizationShortName}/management/site/state`, { token });

const REFRESH_TIME = 15 * 1000;

export const useGetMultiSiteState = () => {
  const token = useToken();
  const organizationShortName = useOrganizationShortName();
  return useQuery({
    queryKey: [QUERY_KEYS.MULTI_SITE, { token, organizationShortName }],
    queryFn: async ({ queryKey }) => {
      const [, queryParams] = queryKey;
      return multiSite(queryParams.token, queryParams.organizationShortName);
    },
    initialData: {},
    refetchInterval: REFRESH_TIME,
    enabled: !!token && !!organizationShortName && FOUNDATION,
  });
};
